import { CalendarOutlined, ClockCircleOutlined, FlagOutlined } from '@ant-design/icons'
import { EventStatus, getHighestPriorityStatus } from './scheduleModel'

const statusConfig = {
  [EventStatus.Planned]: { icon: <CalendarOutlined />, color: '#1890ff' },
  [EventStatus.ClockedIn]: { icon: <ClockCircleOutlined />, color: '#52c41a' },
  [EventStatus.Visited]: { icon: <FlagOutlined />, color: '#8c8c8c' },
}

type Props = {
  status: EventStatus[]
}

const EventStatusIcon = ({ status }: Props) => {
  const config = statusConfig[getHighestPriorityStatus(status)]

  return (
    <span style={{ position: 'relative', display: 'inline-flex', flexShrink: 0, fontSize: 14 }}>
      {config.icon}
      <span style={{
        position: 'absolute',
        top: -3,
        right: -3,
        width: 8,
        height: 8,
        backgroundColor: config.color,
        borderRadius: '50%',
        border: '1px solid white',
      }} />
    </span>
  )
}

export default EventStatusIcon
